(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-bundle-picker"] && !Shopify.designMode) return;
  try {
    class ComponentPicker extends HTMLElement {
    constructor() {
      super();
    }
    clickOutside(e) {
      if (!this.contains(e.target)) {
        this.close();
      }
    }
    close() {
      this.removeAttribute('open');
    }
    open() {
      this.setAttribute('open', '');
    }
    toggle() {
      if (this.hasAttribute('open')) {
        this.close();
      } else {
        this.open();
      }
    }
    updateForm() {
      const form = document.querySelector('bundle-form');
      const index = this.hasAttribute('index') ? Number(this.getAttribute('index')) : -1;
      const variant_id = this.getAttribute('selected');
      if (form && index >= 0 && variant_id) {
        const input = form.querySelector(`[name="component_id[${index}]"]`);
        if (input) {
          input.value = variant_id;
          input.dispatchEvent(new Event('input', { bubbles: true, cancelable: false }));
          form.dispatchEvent(new Event('bundle:component-change', { bubbles: true, cancelable: false }));
        }
      }
    }
    selectVariant(variant) {
      const selected_variant_id = this.getAttribute('selected');
      const selected_image = this.querySelector('.selected-component .component-image');
      const selected_title = this.querySelector('.selected-component .component-title');
      const selected_state = this.querySelector('.selected-component .component-state');
      const new_image = variant.querySelector('.component-image');
      const new_title = variant.querySelector('.component-title');
      const new_variant_id = variant.getAttribute('variant');
      if (!this.hasAttribute('selected')) {
        if (selected_image && new_image) {
          selected_image.innerHTML = new_image.innerHTML;
        }
        if (selected_title && new_title) {
          selected_title.innerHTML = new_title.innerHTML;
        }
        this.setAttribute('selected', new_variant_id);
        variant.remove();
      } else {
        if (selected_image && new_image) {
          const selected_image_clone = selected_image.cloneNode(true);
          selected_image.innerHTML = new_image.innerHTML;
          new_image.innerHTML = selected_image_clone.innerHTML;
          selected_image_clone.remove();
        }
        if (selected_title && new_title) {
          const selected_title_clone = selected_title.cloneNode(true);
          selected_title.innerHTML = new_title.innerHTML;
          new_title.innerHTML = selected_title_clone.innerHTML;
          selected_title_clone.remove();
        }
        this.setAttribute('selected', new_variant_id);
        variant.setAttribute('variant', selected_variant_id);
      }
      this.updateForm();
      this.close();
    }
    connectedCallback() {
      this.querySelectorAll('[toggle]')?.forEach((toggle) => {
        toggle.addEventListener('click', (e) => {
          this.toggle();
        });
      });
      this.querySelectorAll('[variant-toggle]')?.forEach((toggle) => {
        toggle.addEventListener('click', (e) => {
          e.stopImmediatePropagation();
          const variant = e.target.closest('[variant]');
          this.selectVariant(variant);
        });
      });
      this.clickOutsideHandler = this.clickOutside.bind(this);
      document.body.addEventListener('click', this.clickOutsideHandler);
    }
    disconnectedCallback() {
      document.body.removeEventListener('click', this.clickOutsideHandler);
    }
  }
  customElements.define('component-picker', ComponentPicker);

  class ComponentWrapper extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      // keep track of available qty
      this.componentVariants = this.querySelectorAll('.component-variant');
      this.form = document.querySelector('bundle-form');
      if (!!this.form && !!this.componentVariants) {
        this.form.addEventListener('bundle:component-change', (e) => {
          this.selectedVariants = {};
          const componentInputs = this.form.querySelectorAll('input[name^="component_id"]');
          componentInputs.forEach((input) => {
            if (!!input.value && input.value != '') {
              const selected_variant_id = input.value;
              this.selectedVariants[input.value] = this.selectedVariants[input.value] + 1 || 1;
            }
          });
          //disable inputs for variants where input qty == availabe qty
          this.componentVariants.forEach((variant) => {
            const variant_id = variant.getAttribute('variant');
            const maxQty = variant.getAttribute('available-qty');
            const selectedQty = this.selectedVariants[variant_id] || 0;
            if (selectedQty >= maxQty) {
              variant.classList.add('sold-out');
            } else {
              variant.classList.remove('sold-out');
            }
          });
        });
      }
    }
  }
  customElements.define('component-wrapper', ComponentWrapper);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-selling-plans"] && !Shopify.designMode) return;
  try {
    class SellingPlanPicker extends HTMLElement {
    static remembered_purchase_option = null;
    static remembered_selling_plan = null;
    
    constructor() {
      super();
    } 
    disableSellingPlans() {
      this.form_selling_plan.setAttribute('disabled', '');
      this.form_selling_plan.removeAttribute('value');
      this.form_selling_plan.dispatchEvent(new Event('input', { bubbles: true, cancelable: false }));
    }
    setSellingPlan(selling_plan_id) {
      this.form_selling_plan.removeAttribute('disabled');
      this.form_selling_plan.setAttribute('value', selling_plan_id);
      this.form_selling_plan.dispatchEvent(new Event('input', { bubbles: true, cancelable: false }));
    }
    restoreRememberedSelection() {
      if (SellingPlanPicker.remembered_selling_plan) {
        const remembered_input = this.querySelector(`.selling-plan-input[value="${SellingPlanPicker.remembered_selling_plan}"]`);
        if (remembered_input) {
          remembered_input.checked = true;
        }
      }
      if (SellingPlanPicker.remembered_purchase_option) {
        const remembered_option_input = this.querySelector(`input[name="purchase-option"][value="${SellingPlanPicker.remembered_purchase_option}"]`);
        if (remembered_option_input) {
          remembered_option_input.checked = true;
        }
      }
    }
    connectedCallback() {
      this.form = document.querySelector('bundle-form') ?? document.querySelector('.product__form form');
      this.form_selling_plan = this.form.querySelector('input[name="selling_plan"]');
      const purchase_option_inputs = this.querySelectorAll('input[name="purchase-option"]');
      const selling_plan_inputs = this.querySelectorAll('input.selling-plan-input');
      if(!this.form_selling_plan) {
        this.form.insertAdjacentHTML('beforeend', '<input type="hidden" name="selling_plan" disabled>');
        this.form_selling_plan = this.form.querySelector('input[name="selling_plan"]');
      }
      purchase_option_inputs.forEach(purchase_option_input => {
        purchase_option_input.addEventListener('input', e => {
          SellingPlanPicker.remembered_purchase_option = purchase_option_input.value;
          if(purchase_option_input.value === "onetime") {
            this.disableSellingPlans();
          } else {
            const purchase_option = purchase_option_input.closest('.purchase-option');
            let active_selling_plan = purchase_option?.querySelector('.selling-plan-input:checked')?.value;
            if(!active_selling_plan) {
              purchase_option?.querySelector('.selling-plan-input')?.setAttribute('checked', '');
              active_selling_plan = purchase_option?.querySelector('.selling-plan-input:checked')?.value;
            }
            if(active_selling_plan) {
              this.setSellingPlan(active_selling_plan);
            }
          } 
        });
      });
      selling_plan_inputs.forEach(selling_plan_input => {
        selling_plan_input.addEventListener('input', e => {
          let active_selling_plan = selling_plan_input?.value;
          if(active_selling_plan) {
            SellingPlanPicker.remembered_selling_plan = active_selling_plan;
            this.setSellingPlan(active_selling_plan);
          }
        });
      });
      this.restoreRememberedSelection();

      const checkedPurchaseOption = this.querySelector('input[name="purchase-option"]:checked');
      if (checkedPurchaseOption) {
        if (checkedPurchaseOption.value === "subscription") {
          const checkedSellingPlan = this.querySelector('.selling-plan-input:checked');
          if (checkedSellingPlan) {
            this.setSellingPlan(checkedSellingPlan.value);
          } else {
            const firstSellingPlan = this.querySelector('.selling-plan-input');
            if (firstSellingPlan) {
              firstSellingPlan.checked = true;
              this.setSellingPlan(firstSellingPlan.value);
            }
          }
        } else {
          this.disableSellingPlans();
        }
      }
    }
  }
  customElements.define('selling-plan-picker', SellingPlanPicker);
  } catch(e) { console.error(e); }
})();

})();
